import { all } from "redux-saga/effects"

import currentToolSaga from "./current-tool/current-tool.saga"

export default function* rootSaga() {
  yield all([currentToolSaga()])
}
